import React, { useState } from "react";
import "../assets/css/Login.css";
import { FaEnvelope, FaLock } from "react-icons/fa";
import LoginPc from "../assets/images/computer.png";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

const loginSchema = yup.object().shape({
  Username: yup.string().required("User Name Is Required"),
  Password: yup.string().required("Password Is Required"),
  RoleID: yup.number().required("Role Is Required"),
});

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await axios.post(
        "https://tarabotcs.com-eg.net/api/Users/V1/Login",
        data,
        {
          headers: {
            CompanyID: "221005",
          },
        }
      );

      // التحقق من نجاح عملية تسجيل الدخول
      if (response.data.Success) {
        // حفظ بيانات المستخدم في localStorage
        localStorage.setItem("userData", JSON.stringify(response.data));
        navigate("/home-page");
      } else {
        setErrorMessage("بيانات الدخول غير صحيحة");
      }
    } catch (error) {
      // إذا كان الرد يحتوي على حالة 401 Unauthorized
      if (error.response && error.response.status === 401) {
        // مسح بيانات المستخدم والخروج
        localStorage.removeItem("userData");
        navigate("/"); // التوجيه إلى الصفحة الرئيسية
      } else {
        setErrorMessage("حدث خطأ أثناء محاولة تسجيل الدخول");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-login">
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "#e9e2e2",
            zIndex: 1000,
          }}
        >
          <CircularProgress size={80} />
        </div>
      ) : (
        <div className="login-container">
          <div className="login-card">
            <div className="login-image">
              <img src={LoginPc} alt="Login Illustration" />
            </div>
            <div className="login-form">
              <h2>{t("login")}</h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="input-group">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="text"
                    placeholder={t("username")}
                    {...register("Username")}
                  />
                  {errors.Username && (
                    <p className="error-message">{errors.Username.message}</p>
                  )}
                </div>
                <div className="input-group">
                  <FaLock className="input-icon" />
                  <input
                    type="password"
                    placeholder={t("password")}
                    {...register("Password")}
                  />
                  {errors.Password && (
                    <p className="error-message">{errors.Password.message}</p>
                  )}
                </div>
                <div className="input-group">
                  <FormControl fullWidth>
                    <InputLabel id="role-select-label">
                      {t("selectRole")}
                    </InputLabel>
                    <Select
                      labelId="role-select-label"
                      id="role-select"
                      defaultValue=""
                      {...register("RoleID")}
                      sx={{ backgroundColor: "#e9e2e2", borderRadius: "20px" }}
                    >
                      <MenuItem value="1">Admin</MenuItem>
                      <MenuItem value="2">Agent</MenuItem>
                    </Select>
                  </FormControl>
                  {errors.RoleID && (
                    <p className="error-message">{errors.RoleID.message}</p>
                  )}
                </div>

                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
                <div className="input-group">
                  <button
                    type="submit"
                    className="login-button"
                    disabled={loading}
                  >
                    {t("login")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
